import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import colorSet from '@/src/styles/color';

function FullLoading() {
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 z-toast flex items-center justify-center bg-white">
      <PulseLoader color={colorSet.blue4} />
    </div>
  );
}

export default FullLoading;
